import { ReactNode } from 'react';

import styles from './table.module.css';

export type TableProps = {
	children: ReactNode | ReactNode[];
};

export const Table = ({ children }: TableProps) => {
	return (
		<div className={styles.wrapper}>
			<table className={styles.table}>{children}</table>
		</div>
	);
};
